import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import * as config from '../config/config';
// Import components
import Header from '../components/header'
import '../styles/index.scss'
import Hero from '../components/hero'
import EmailProtection from '../components/email-protection';

// State management
import {Provider} from 'react-redux';
import configureStore from '../store';

// Basic page configuration
const store = configureStore();

const TemplateWrapper = ({ children, history }) => {
    return (
        <Provider store={store}>
            <div>
                <Header history={history} />
                <div className="main-content">
                    {children()}
                </div>

                <section className="hero is-primary">
                    <div className="hero-body">
                        <div className="container has-text-centered">
                            <h2 className="subtitle">
                                Vragen of reserveren? Bel of app tussen 09:00 uur en 21:00 uur met <strong><a href="https://api.whatsapp.com/send?phone=31644066185">+31 (0)6 - 440 661 85</a></strong>.
                            </h2>
                        </div>
                    </div>
                </section>
                <footer className="footer is-danger">
                    <div className="container">
                        <div className="columns">
                            <div className="column">
                                <div itemScope itemType="http://schema.org/LocalBusiness" className="has-text-white">
                                    <p>
                                        <strong className="has-text-white" >Gifture Photobooth</strong> <br />
                                        <span itemProp="address" itemScope="" itemType="http://schema.org/PostalAddress">
                                        <span itemProp="streetAddress">Gravin Juliana van Stolberglaan 119</span><br />
                                        <span itemProp="postalCode">2263AM</span>,
                                        <span itemProp="addressLocality"> Leidschendam</span>
                                        <br />
                                        <span itemProp="addressRegion">Zuid-Holland</span>
                                        <br />
                                        <a href="https://www.google.com/maps/dir//Gravin+Juliana+Van+Stolberglaan+119+Leidschendam+Nederland" target="_blank">Plan Route</a>
                                    </span>

                                        <span itemProp="geo" itemScope="" itemType="http://schema.org/GeoCoordinates">
                                        <meta itemProp="latitude" content="52.0970087" />
                                        <meta itemProp="longitude" content="4.4031287" />
                                    </span>
                                    </p>
                                    <ul className="social-media-links">
                                        <li>
                                            <a href="https://facebook.com/gifturephotobooth" target="_blank">
                                                <i className="footer__icon icon-facebook" />
                                                <span className="is-hidden-tablet">
                                                @gifturephotobooth
                                                </span>
                                                <span className="is-hidden-mobile">
                                                    facebook.com/gifturephotobooth
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://instagram.com/gifture_photobooth" target="_blank">
                                                <i className="footer__icon icon-instagram" />
                                                <span className="is-hidden-tablet">
                                                    @gifture_photobooth
                                                </span>
                                                <span className="is-hidden-mobile">
                                                    instagram.com/gifture_photobooth
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="footer__icon icon-mail3" />
                                                <EmailProtection address="info@gifture.nl" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="tel:0644066185">
                                                <i className="footer__icon icon-whatsapp" />
                                                <span>
                                                    +31 (0)6 - 440 661 85
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="column" />
                            <div className="column" />
                            <div className="column">
                                <div className="buttons">
                                    <Link className="button is-primary" to="/reserveren">Photobooth huren</Link>
                                    <Link to="/algemene-voorwaarden">Algemene voorwaarden</Link>
                                    {/*<Link className="button is-primary" to="/informatiepakket-aanvragen">Informatiepakket aanvragen</Link>*/}
                                </div>
                                <Link to="/gifture-merken">Gifture Concepts</Link>

                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </Provider>
    )
}

TemplateWrapper.propTypes = {
    children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js